import kamala from '../../kamala'
import Toast from './Toast'

Toast.install = function (Vue) {
  if (Toast.__installed) {
    // eslint-disable-line
    return
  }

  kamala(Vue)

  Vue.prototype.$toast = Toast.toast
}

export default Toast
